import { publicApi } from '../../services/api';

export const getPublicNfeInfo = (tenantId: string, token: string) =>
  publicApi.get(`/public/nfe/${tenantId}/${token}`);

export const submitPublicNfe = (tenantId: string, token: string, payload: any) =>
  publicApi.post(`/public/nfe/${tenantId}/${token}`, payload);

export const uploadPublicNfeFile = (
  tenantId: string,
  token: string,
  file: File,
  submitterName: string,
  uid: string,
  description: string,
  onUploadProgress?: (percent: number) => void,
) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('uid', uid);
  formData.append('submitter_name', submitterName);
  formData.append('description', description);

  return publicApi.post(`/public/nfe/${tenantId}/${token}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onUploadProgress
      ? (e: any) => {
          const percent = e.total ? Math.round((e.loaded * 100) / e.total) : 0;
          onUploadProgress(percent);
        }
      : undefined,
  });
};
